const LinkExternal = (props) => {
    return <a {...props} target="_blank" rel="noreferrer">{props.children}<span className="visually-hidden"> Opens in a new tab</span></a>
};

export default LinkExternal;